module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column--single img--140 text--blue"
  }, [_c('div', {
    staticClass: "column--single"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.currentTab === _vm.tabs.all) ? _c('div', {
    staticClass: "column--single"
  }, [_c('div', {
    staticClass: "column--half-left"
  }, [_c('h3', {
    staticClass: "bold caps center"
  }, [_vm._v("Korean Anatomy")]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/01-kr-pillars.svg",
      "alt": "Pillars"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Pillars "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(겸기둥)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The two bars specific to letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅐ, ㅒ, ㅔ,")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅖ.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/02-kr-beak.svg",
      "alt": "Beak"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Beak "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(부리)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The top-most accent mark influenced from when the brush first touches paper.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/03-kr-hor-stem.svg",
      "alt": "Horizontal Stem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Horizontal Stem "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(기로줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("A horizontal stroke with at least one stroke prior.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/04-kr-vertex.svg",
      "alt": "Vertex"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Vertex "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(꼭지점)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Similar to the dotted i, the vertex is specific to the top part of letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅊ")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅎ.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/05-kr-side-stroke.svg",
      "alt": "Side Stroke"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Side Stroke "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(곁줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Specific to the letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅓ, ㅏ, ㅔ,")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅖ.")]), _vm._v(" It is shorter than the horizontal stem.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/06-kr-stem-joint.svg",
      "alt": "Stem Joint"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Stem Joint "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(이음줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Refers to what happens when a letter connects upwards toward the letter next to it.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/07-kr-short-column.svg",
      "alt": "Short Column"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Short Column "), _c('span', {
    staticClass: "kr-sans-bold no-break"
  }, [_vm._v("(짧은기둥)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The part that sticks out vertically, specific to the letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅗ")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅜ.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/08-kr-bow.svg",
      "alt": "Bow"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Bow "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(보)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("A horizontal stroke, normally with only one or two strokes prior or after.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/09-kr-vertical-stem.svg",
      "alt": "Vertical Stem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Vertical Stem "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(세로줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("A long vertical stroke that is followed by at least one vertical stroke.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/10-kr-round-stem.svg",
      "alt": "Round Stem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Round Stem "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(둥근줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Only found in the letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅇ")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅎ.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/11-kr-topknot.svg",
      "alt": "Topknot"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Topknot "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(상투)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("An accent from the initial brush mark on paper.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column--half-right text--blue"
  }, [_c('h3', {
    staticClass: "bold caps center"
  }, [_vm._v("English Anatomy")]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/01-en-counter.svg",
      "alt": "Counter"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Counter")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Enclosed spaces.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/02-en-arch.svg",
      "alt": "Arch"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Arch")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Upper curves.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/03-en-serif.svg",
      "alt": "Serif"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Serif")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("From the process of carving letters into stone. The serif marks the first strike into the stone.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/04-en-serif-bracket.svg",
      "alt": "Serif Brakcet"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Serif Bracket")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The style of the serif connected to the stem.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/05-en-outstroke.svg",
      "alt": "Outstroke"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Outstroke")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("A stylized serif, used to end the last stroke of a letter.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/06-en-ascender.svg",
      "alt": "Ascender"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Ascender")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The part of a stem that rises above the meanline.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/07-en-stem.svg",
      "alt": "Stem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Stem")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Any vertical stroke. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/08-en-descender.svg",
      "alt": "Descender"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Desender")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The part that hangs below the baseline.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/09-en-bowl.svg",
      "alt": "Bowl"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Bowl")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Any rounded part that contains a counter space.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/10-en-beak.svg",
      "alt": "Beak"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Beak")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The extension of the serif, usually located at the top of letters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/11-en-finial.svg",
      "alt": "FInial"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Finial/End Stroke")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("An unstylized way of ending the last stroke.")])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.currentTab === _vm.tabs.korean) ? _c('div', [_c('div', {
    staticClass: "column--single"
  }, [_c('h3', {
    staticClass: "bold caps center"
  }, [_vm._v("Korean Anatomy")]), _vm._v(" "), _c('div', {
    staticClass: "column--half-left"
  }, [_c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/01-kr-pillars.svg",
      "alt": "Pillars"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Pillars "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(겸기둥)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The two bars specific to letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅐ, ㅒ, ㅔ,")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅖ.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/02-kr-beak.svg",
      "alt": "Beak"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Beak "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(부리)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The top-most accent mark influenced from when the brush first touches paper.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/03-kr-hor-stem.svg",
      "alt": "Horizontal Stem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Horizontal Stem "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(기로줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("A horizontal stroke with at least one stroke prior.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/04-kr-vertex.svg",
      "alt": "Vertex"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Vertex "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(꼭지점)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Similar to the dotted i, the vertex is specific to the top part of letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅊ")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅎ.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/05-kr-side-stroke.svg",
      "alt": "Side Stroke"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Side Stroke "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(곁줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Specific to the letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅓ, ㅏ, ㅔ,")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅖ.")]), _vm._v(" It is shorter than the horizontal stem.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/06-kr-stem-joint.svg",
      "alt": "Stem Joint"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Stem Joint "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(이음줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Refers to what happens when a letter connects upwards toward the letter next to it.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column--half-right"
  }, [_c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/07-kr-short-column.svg",
      "alt": "Short Column"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Short Column "), _c('span', {
    staticClass: "kr-sans-bold no-break"
  }, [_vm._v("(짧은기둥)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The part that sticks out vertically, specific to the letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅗ")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅜ.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/08-kr-bow.svg",
      "alt": "Bow"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Bow "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(보)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("A horizontal stroke, normally with only one or two strokes prior or after.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/09-kr-vertical-stem.svg",
      "alt": "Vertical Stem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Vertical Stem "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(세로줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("A long vertical stroke that is followed by at least one vertical stroke.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/10-kr-round-stem.svg",
      "alt": "Round Stem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Round Stem "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(둥근줄기)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Only found in the letters "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅇ")]), _vm._v(" and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅎ.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/11-kr-topknot.svg",
      "alt": "Topknot"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps no-break"
  }, [_vm._v("Topknot "), _c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("(상투)")])]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("An accent from the initial brush mark on paper.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--medium"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.currentTab === _vm.tabs.english) ? _c('div', [_c('div', {
    staticClass: "column--single text--blue"
  }, [_c('h3', {
    staticClass: "bold caps center"
  }, [_vm._v("English Anatomy")]), _vm._v(" "), _c('div', {
    staticClass: "column--half-left"
  }, [_c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/01-en-counter.svg",
      "alt": "Counter"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Counter")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Enclosed spaces.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/02-en-arch.svg",
      "alt": "Arch"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Arch")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Upper curves.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/03-en-serif.svg",
      "alt": "Serif"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Serif")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("From the process of carving letters into stone. The serif marks the first strike into the stone.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/04-en-serif-bracket.svg",
      "alt": "Serif Brakcet"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Serif Bracket")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The style of the serif connected to the stem.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/05-en-outstroke.svg",
      "alt": "Outstroke"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Outstroke")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("A stylized serif, used to end the last stroke of a letter.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/06-en-ascender.svg",
      "alt": "Ascender"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Ascender")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The part of a stem that rises above the meanline.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column--half-right"
  }, [_c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/07-en-stem.svg",
      "alt": "Stem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Stem")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Any vertical stroke. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/08-en-descender.svg",
      "alt": "Descender"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Desender")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The part that hangs below the baseline.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/09-en-bowl.svg",
      "alt": "Bowl"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Bowl")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("Any rounded part that contains a counter space.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/10-en-beak.svg",
      "alt": "Beak"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Beak")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("The extension of the serif, usually located at the top of letters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small flex-h-center"
  }, [_c('div', {
    staticClass: "column--one-fourth"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/letter-form-anatomy/11-en-finial.svg",
      "alt": "FInial"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('div', {
    staticClass: "bold caps"
  }, [_vm._v("Finial/End Stroke")]), _vm._v(" "), _c('div', {
    staticClass: "serif caption--max-width"
  }, [_vm._v("An unstylized way of ending the last stroke.")])])])])])]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31abc150","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LetterFormAnatomyToggle.vue
// module id = 137
// module chunks = 0